import React from 'react';
import MaterialTable, { MTableEditRow } from 'material-table';

const GuardedEditRow = ({ startEditing, finishEditing, ...editRowProps }) => {
    React.useEffect(() => {
        startEditing();
        return finishEditing;
    }, [startEditing, finishEditing]);

    return <MTableEditRow {...editRowProps} />;
};

// material-table 1.x reconstruye sus datos internos cuando cambia `data`.
// Si esto ocurre durante una edición inline, pierde el borrador de la fila.
// Conservamos la vista hasta que la edición termina y entonces aplicamos el
// último cambio recibido desde Firestore.
const LiveMaterialTable = ({ data, components, ...props }) => {
    const [displayData, setDisplayData] = React.useState(data);
    const editingRef = React.useRef(false);
    const latestDataRef = React.useRef(data);

    const finishEditing = React.useCallback(() => {
        editingRef.current = false;
        setDisplayData(latestDataRef.current);
    }, []);

    const startEditing = React.useCallback(() => {
        editingRef.current = true;
    }, []);

    const renderEditRow = React.useCallback(editRowProps => {
        return <GuardedEditRow {...editRowProps} startEditing={startEditing} finishEditing={finishEditing} />;
    }, [startEditing, finishEditing]);

    React.useEffect(() => {
        latestDataRef.current = data;
        if (!editingRef.current) {
            setDisplayData(data);
        }
    }, [data]);

    const tableComponents = React.useMemo(() => ({
        ...components,
        EditRow: renderEditRow
    }), [components, renderEditRow]);

    return <MaterialTable {...props} data={displayData} components={tableComponents} />;
};

export default LiveMaterialTable;
